import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getUsers, deleteUser, updateUserRole } from '../services/api';

const roleColors = { admin: { bg: '#e8f0ff', color: '#0066FF' }, employer: { bg: '#e6fff6', color: '#00C896' }, jobseeker: { bg: '#fff8e6', color: '#f59e0b' } };

export default function Users() {
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [filter, setFilter]   = useState('all');

  useEffect(() => {
    getUsers()
      .then(data => { setUsers(data.users || data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    await deleteUser(id);
    setUsers(users.filter(u => u._id !== id));
  };

  const handleRole = async (id, role) => {
    await updateUserRole(id, role);
    setUsers(users.map(u => u._id === id ? { ...u, role } : u));
  };

  const filtered = users.filter(u => {
    const matchSearch = u.name?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === 'all' || u.role === filter;
    return matchSearch && matchFilter;
  });

  return (
    <Layout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Users</h2>
          <p style={{ color: '#888', fontSize: 14, margin: 0 }}>{users.length} total registered users</p>
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220, display: 'flex', alignItems: 'center', gap: 10, background: '#fff', border: '1.5px solid #eef0f8', borderRadius: 10, padding: '10px 14px' }}>
          <i className="fa fa-search" style={{ color: '#aaa' }}></i>
          <input type="text" placeholder="Search by name or email..." value={search} onChange={e => setSearch(e.target.value)}
            style={{ border: 'none', outline: 'none', fontSize: 13, background: 'transparent', width: '100%' }} />
        </div>
        {['all', 'admin', 'employer', 'jobseeker'].map(r => (
          <button key={r} onClick={() => setFilter(r)} style={{ padding: '10px 18px', borderRadius: 10, border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer', background: filter === r ? '#0066FF' : '#fff', color: filter === r ? '#fff' : '#555', boxShadow: filter === r ? '0 4px 12px rgba(0,102,255,0.25)' : '0 2px 8px rgba(0,0,0,0.05)' }}>
            {r.charAt(0).toUpperCase() + r.slice(1)}
          </button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8faff' }}>
              {['User', 'Email', 'Role', 'Joined', 'Actions'].map(h => (
                <th key={h} style={{ padding: '14px 20px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}><i className="fa fa-spinner fa-spin me-2"></i>Loading...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}>No users found</td></tr>
            ) : filtered.map((u, i) => (
              <tr key={u._id} style={{ borderTop: '1px solid #f5f5f5' }}>
                <td style={{ padding: '14px 20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#e8f0ff', color: '#0066FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14, flexShrink: 0 }}>
                      {u.name?.charAt(0).toUpperCase()}
                    </div>
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#0A1628' }}>{u.name}</span>
                  </div>
                </td>
                <td style={{ padding: '14px 20px', fontSize: 13, color: '#555' }}>{u.email}</td>
                <td style={{ padding: '14px 20px' }}>
                  <select value={u.role} onChange={e => handleRole(u._id, e.target.value)}
                    style={{ padding: '5px 10px', borderRadius: 8, border: `1.5px solid ${roleColors[u.role]?.color || '#eee'}`, background: roleColors[u.role]?.bg, color: roleColors[u.role]?.color, fontWeight: 700, fontSize: 12, cursor: 'pointer', outline: 'none' }}>
                    <option value="jobseeker">Jobseeker</option>
                    <option value="employer">Employer</option>
                    <option value="admin">Admin</option>
                  </select>
                </td>
                <td style={{ padding: '14px 20px', fontSize: 13, color: '#888' }}>{new Date(u.createdAt).toLocaleDateString()}</td>
                <td style={{ padding: '14px 20px' }}>
                  <button onClick={() => handleDelete(u._id)} style={{ padding: '6px 14px', borderRadius: 8, border: 'none', background: '#fff0f0', color: '#ef4444', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>
                    <i className="fa fa-trash me-1"></i> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
